import { hasPath } from 'ramda';

// Check if the given data path is present in the current state
export const isStatePath = (currentState, dataPath) => {
	return Array.isArray(dataPath) && hasPath(dataPath, currentState);
}
